import { Skeleton as MuiSkeleton } from '@mui/material';
import type { SkeletonProps as MuiSkeletonProps } from '@mui/material';

/** Basic Skeleton component to use as fallback when components are loaded dynamically. Based on MUI Skeleton: https://mui.com/material-ui/react-skeleton/ */
export const Skeleton = (props: MuiSkeletonProps) => (
  <MuiSkeleton data-testid="skeleton" {...props} />
);
